import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=1c45010d&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=1c45010d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45010d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c45010d')) {
      api.createRecord('1c45010d', component.options)
    } else {
      api.reload('1c45010d', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=1c45010d&scoped=true", function () {
      api.rerender('1c45010d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/components/Banner/Banner.vue"
export default component.exports